/*
  trenddecay: collapse the product description after ~N characters with a More/Less toggle.
  The full description stays in the HTML (SEO, no-JS fallback shows everything); this only
  clips the display at the line containing character N. See artifacts/theme-customizations.md.
*/
(function () {
  function cutHeight(el, limit) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (n.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
    });
    let count = 0;
    let node;
    while ((node = walker.nextNode())) {
      const len = node.textContent.length;
      if (count + len >= limit) {
        const offset = Math.max(1, limit - count);
        const range = document.createRange();
        range.setStart(node, offset - 1);
        range.setEnd(node, offset);
        const rects = range.getClientRects();
        const rect = rects.length ? rects[rects.length - 1] : range.getBoundingClientRect();
        return Math.ceil(rect.bottom - el.getBoundingClientRect().top);
      }
      count += len;
    }
    return null; // shorter than the limit
  }

  function measure(el) {
    const collapsed = el.classList.contains('td-more--collapsed');
    el.classList.remove('td-more--collapsed'); // measure at full height
    const cut = cutHeight(el, parseInt(el.dataset.tdMore, 10) || 400);
    const needed = cut !== null && cut < el.scrollHeight - 4;
    if (needed) el.style.setProperty('--td-cut', cut + 'px');
    if (collapsed && needed) el.classList.add('td-more--collapsed');
    return needed;
  }

  function setup(el) {
    if (el.dataset.tdReady) return;
    el.dataset.tdReady = '1';
    if (!measure(el)) return;

    el.classList.add('td-more', 'td-more--collapsed');
    if (!el.id) el.id = 'ProductDescription-' + Math.random().toString(36).slice(2, 8);
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'td-more__toggle';
    btn.textContent = 'More';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', el.id);
    btn.addEventListener('click', () => {
      const collapsed = el.classList.toggle('td-more--collapsed');
      btn.textContent = collapsed ? 'More' : 'Less';
      btn.setAttribute('aria-expanded', String(!collapsed));
      if (collapsed) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
    el.after(btn);

    let t;
    window.addEventListener('resize', () => {
      clearTimeout(t);
      t = setTimeout(() => measure(el), 150); // line wrapping changes with width
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-td-more]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
